<template>
  <div class="card-email-notifications-content" style="position: relative"
       :class="{'not-editable':editSection !== '' && editSection !== title}">
    <b-loading :active="editSection !== '' && editSection !== title"
               animation="unset" :is-full-page="false">
      <slot>{{''|upper}}</slot>
    </b-loading>
    <template v-if="editSection!=='Email Notifications'">
      <div>
        <p class="card-content-title">
          Personalize your email notifications that will be sent to your inbox.
        </p>
        <ul class="personal-card-email-notifications">
          <li class="personal-card-email-notifications-item status">
            <b-icon pack="fal" size="is-small"
                    :icon="isNotificationDisabled ? 'bell-slash fa-flip-horizontal' : 'bell'"
                    style="color: #8FA7B3"></b-icon>
            <p>Notifications are {{isNotificationDisabled ? 'disabled' : 'enabled'}}</p>
          </li>
        </ul>
      </div>
      <div class="personal-card-controls">
        <button class="button is-success"
                @click="$emit('edit-card', 'Email Notifications')">EDIT</button>
      </div>
    </template>
    <template v-else>
      <b-field class="list-description">
        <p>
          Personalize your email notifications that will be sent to <b>{{userEmail}}</b>
        </p>
      </b-field>
      <section class="notification-options-list">
        <b-field class="options" v-for="option in options" :key="option.data.key">
          <b-radio v-model="checkedOptionTitle" :native-value="option.data.title">
            {{option.data.title}}
          </b-radio>
        </b-field>
      </section>
      <div class="buttons">
        <button class="button button-cancel" @click="onCancel">Cancel</button>
        <button class="button is-success" @click="onSubmit">Submit</button>
      </div>
    </template>
  </div>
</template>

<script>

import { mapMutations, mapState } from 'vuex';
import * as MUTATION from '@/store/mutations';
import { getUserEmailNotification, updateUserEmailNotification } from '@/api/user';
import { getNotificationEmailOptions } from '@/api/notification';


export default {
  data() {
    return {
      id: null,
      options: [],
      checkedOptionTitle: '',
      checkedOption: {},
      checkedOptionSaved: {},
    };
  },
  name: 'CardEmailNotifications',
  props: {
    editSection: {
      type: String,
      default: '',
    },
    title: {
      type: String,
      default: null,
    },
  },
  watch: {
    /** Hack, for run computed.stateToLocal */
    stateToLocal() {
      // pass
    },
  },
  computed: {
    ...mapState('user', { userId: (state) => state.id, userEmail: (state) => state.email }),
    stateToLocal() {
      return Object.keys(this.$store.state.contractor).forEach((key) => {
        this[key] = this.$store.state.contractor[key];
      });
    },
    isNotificationDisabled() {
      return this.checkedOptionSaved.data && this.checkedOptionSaved.data.key === 'do_not_notify';
    },
  },
  async activated() {
    this.preloader(true);
    const { data } = await getUserEmailNotification(this.userId);
    const { data: options } = await getNotificationEmailOptions();
    const notifications = [];
    if (options) {
      options.data.forEach((value) => {
        if (value.key === 'notify_every_step') {
          notifications.push({ order: 1, data: value });
        }
        if (value.key === 'notify_receive_offers') {
          notifications.push({ order: 2, data: value });
        }
        if (value.key === 'notify_receive_funding') {
          notifications.push({ order: 3, data: value });
        }
        if (value.key === 'do_not_notify') {
          notifications.push({ order: 4, data: value });
        }
      });
      notifications.sort((a, b) => a.order - b.order);
      this.options = notifications;
    } else {
      this.options = [];
    }
    if (data) {
      this.checkedOption = this.options.find((element) => element.data.key === data.option.key);
      this.checkedOptionSaved = this.checkedOption;
      this.checkedOptionTitle = this.checkedOption.data.title;
    } else {
      this.checkedOption = this.options.find((element) => element.data.key === 'notify_every_step');
      this.checkedOptionSaved = {};
      this.checkedOptionTitle = this.checkedOption.data.title;
    }
    this.preloader(false);
  },

  methods: {
    ...mapMutations({ preloader: MUTATION.SET_PRELOADER }),
    onCancel() {
      this.setSectionNotEditable();
    },
    async onSubmit() {
      this.preloader(true);
      try {
        this.checkedOption = this.options.find(
          (element) => element.data.title === this.checkedOptionTitle,
        );
        await updateUserEmailNotification({
          id: this.userId,
          optionKey: this.checkedOption.data.key,
        });
        this.checkedOptionSaved = this.checkedOption;
        this.checkedOptionTitle = this.checkedOption.data.title;
        this.$buefy.toast.open({ message: 'Update successful!', type: 'is-success' });
        this.setSectionNotEditable();
      } catch (error) {
        const message = this.lodash.get(error, 'response.data.message', 'An unexpected error occurred, please contact support@enhancify.com');
        this.$buefy.snackbar.open({
          message,
          actionText: ' ',
          position: 'is-top',
          indefinite: true,
          type: 'is-danger',
        });
      }
      this.preloader(false);
    },

    setSectionNotEditable(reset = null) {
      if (typeof reset === 'function') reset();
      if (this.checkedOptionSaved.data) {
        this.checkedOption = this.checkedOptionSaved;
        this.checkedOptionTitle = this.checkedOptionSaved.data.title;
      } else {
        this.checkedOption = this.options.find((element) => element.data.key === 'notify_every_step');
        this.checkedOptionSaved = {};
        this.checkedOptionTitle = this.checkedOption?.data.title;
      }
      this.$emit('edit-card', '');
    },
  },
  deactivated() {
    this.setSectionNotEditable();
  },
};
</script>

<style lang="stylus" scoped>
.notification-options-list
  margin-bottom 30px
.options:not(:last-child)
  border-bottom 1px solid #E9E9E9
  padding-bottom 0.75rem
b-radio.radio span.check
  color #6ABA65!important
.card-email-notifications-content
  color #525F66
  display flex
  min-height 220px
  height 100%
  padding-top 15px
  flex-direction column
  justify-content space-between
  >>>.personal-info__field-label
    font-weight 400
    color #8A9499
  >>> .field.personal-info__field
    input, span
      height 48px
  >>>.card-content-title
    margin-bottom 15px

.personal-card-email-notifications
  list-style-type none
  margin-left 15px
  position relative
  >li
    display flex
    margin 10px
    position relative
    &.status span.icon
      top 4px
      left -24px
    span.icon
      position absolute
      >>> i:before
        color rgb(143,167,179)
        font-weight 600
.field.list-description
  word-break break-word
  margin-bottom 20px
  b
    word-break break-all
.personal-card-controls
  display flex
  justify-content right
.buttons
  justify-content right
button.button
  width 135px
  height 48px
  border 1px solid #23D160
  font-size 19px
  text-transform uppercase
.button.is-success
  border none
.button.button-cancel
  color #23D160
.button.button-cancel:hover
  background #17b548
  color white
.loading-overlay >>> .loading-background
  background rgba(255,255,255,0.8)

</style>
